import { NodeType, StructureNode, parseQuestionnaireStructure } from "./structureParser"

// The other elements a label can name, after its question
const NAMED_TYPES = new Set<NodeType>([
  NodeType.SECTION,
  NodeType.LIST,
  NodeType.RANGE_LIST,
  NodeType.TEXT,
  NodeType.NOTE,
])

// A hidden question or a data field: the keyword and the label, nothing after it
const VARIABLE_LINE = /^(?:HIDDEN|DATA)\s+(.+)$/

// The editor can leave non-breaking spaces in the text
const normLabel = (s: string): string => s.replace(/\u00A0/g, " ").trim().toLowerCase()

/**
 * The line (from 1) that declares `label` in a questionnaire text: its question (`Q <label>:`,
 * `HIDDEN <label>` or `DATA <label>`), else the section, list, text or note of that name. Null
 * when nothing declares it; a mention elsewhere (piping, a comment, a logic line) never counts.
 */
export const findLabelLine = (text: string, label: string): number | null => {
  const wanted = normLabel(label)
  if (!wanted) return null

  const questions: number[] = []
  const others: number[] = []
  const collect = (node: StructureNode): void => {
    if (normLabel(node.name) === wanted) {
      if (node.type === NodeType.QUESTION) questions.push(node.lineNumber)
      else if (NAMED_TYPES.has(node.type)) others.push(node.lineNumber)
    }
    node.children?.forEach(collect)
  }
  collect(parseQuestionnaireStructure(text))

  // The structure doesn't list hidden questions and data fields as questions
  text.split("\n").forEach((line, i) => {
    const declared = line.trim().match(VARIABLE_LINE)
    if (declared && normLabel(declared[1]) === wanted) questions.push(i + 1)
  })

  if (questions.length) return Math.min(...questions)
  return others.length ? Math.min(...others) : null
}
